/**
 * Ecosystem network coverage shown on the "Data is our Moat" slide.
 *
 * `directoryCoverage` = organizations indexed in StartupFuel directories.
 * Inclusion does NOT imply a partnership or an active data feed.
 * `activeContributors` = verified organizations actively supplying data
 * (null until confirmed — never inferred from directory inclusion).
 */

export type Region = {
  id: 'canada' | 'midwest' | 'europe'
  name: string
  tone: string
  directoryCoverage: number | null
  directoryNote: string
  activeContributors: number | null
  /** Where the region label sits on the map. */
  label: { lat: number; lon: number }
  /** Ecosystem hubs used to place the organization cluster. */
  hubs: { city: string; lat: number; lon: number }[]
}

export const regions: Region[] = [
  {
    id: 'canada',
    name: 'Canada',
    tone: '#3B8CFF',
    directoryCoverage: 259,
    directoryNote: 'CAIN accelerators & incubators, designated organizations, angel networks',
    activeContributors: null,
    label: { lat: 63, lon: -122 },
    hubs: [
      { city: 'Vancouver', lat: 49.28, lon: -123.12 },
      { city: 'Victoria', lat: 48.43, lon: -123.37 },
      { city: 'Calgary', lat: 51.05, lon: -114.07 },
      { city: 'Edmonton', lat: 53.55, lon: -113.49 },
      { city: 'Saskatoon', lat: 52.13, lon: -106.67 },
      { city: 'Winnipeg', lat: 49.9, lon: -97.14 },
      { city: 'Waterloo', lat: 43.46, lon: -80.52 },
      { city: 'Ottawa', lat: 45.42, lon: -75.7 },
      { city: 'Montréal', lat: 45.5, lon: -73.57 },
      { city: 'Québec City', lat: 46.81, lon: -71.21 },
      { city: 'Fredericton', lat: 45.96, lon: -66.64 },
      { city: 'Halifax', lat: 44.65, lon: -63.57 },
      { city: "St. John's", lat: 47.56, lon: -52.71 },
    ],
  },
  {
    id: 'midwest',
    name: 'US Midwest',
    tone: '#9B7BFF',
    directoryCoverage: 243,
    directoryNote: 'IL · WI · MI · OH · IA · IN · KY · MN · MO',
    activeContributors: null,
    label: { lat: 31.5, lon: -104 },
    hubs: [
      { city: 'Chicago', lat: 41.88, lon: -87.63 },
      { city: 'Milwaukee', lat: 43.04, lon: -87.91 },
      { city: 'Madison', lat: 43.07, lon: -89.4 },
      { city: 'Detroit', lat: 42.33, lon: -83.05 },
      { city: 'Ann Arbor', lat: 42.28, lon: -83.74 },
      { city: 'Columbus', lat: 39.96, lon: -83.0 },
      { city: 'Cleveland', lat: 41.5, lon: -81.69 },
      { city: 'Cincinnati', lat: 39.1, lon: -84.51 },
      { city: 'Des Moines', lat: 41.59, lon: -93.62 },
      { city: 'Indianapolis', lat: 39.77, lon: -86.16 },
      { city: 'Louisville', lat: 38.25, lon: -85.76 },
      { city: 'Minneapolis', lat: 44.98, lon: -93.27 },
      { city: 'St. Louis', lat: 38.63, lon: -90.2 },
      { city: 'Kansas City', lat: 39.1, lon: -94.58 },
    ],
  },
  {
    id: 'europe',
    name: 'Europe',
    tone: '#2FBE8F',
    directoryCoverage: null,
    directoryNote: 'Existing European ecosystem dataset',
    activeContributors: null,
    label: { lat: 64, lon: 4 },
    hubs: [
      { city: 'Dublin', lat: 53.35, lon: -6.26 },
      { city: 'London', lat: 51.51, lon: -0.13 },
      { city: 'Paris', lat: 48.86, lon: 2.35 },
      { city: 'Amsterdam', lat: 52.37, lon: 4.9 },
      { city: 'Berlin', lat: 52.52, lon: 13.4 },
      { city: 'Munich', lat: 48.14, lon: 11.58 },
      { city: 'Zurich', lat: 47.38, lon: 8.54 },
      { city: 'Stockholm', lat: 59.33, lon: 18.07 },
      { city: 'Helsinki', lat: 60.17, lon: 24.94 },
      { city: 'Madrid', lat: 40.42, lon: -3.7 },
      { city: 'Lisbon', lat: 38.72, lon: -9.14 },
      { city: 'Milan', lat: 45.46, lon: 9.19 },
    ],
  },
]

/** StartupFuel / DiligenceGPT™ hub on the map (Toronto). */
export const platformHub = { name: 'StartupFuel / DiligenceGPT™', lat: 43.65, lon: -79.38 }

export const DIRECTORY_SOURCE =
  'Directory coverage: StartupFuel Combined Directory (Canada, 259 records) and Midwest Ecosystem workbook (243 organizations). Directory inclusion does not imply a partnership or an active data feed.'
